import React, { Component } from 'react'
import { Link, Redirect } from 'react-router-dom'
import { Button, Modal, Card, Menu, Row, Col, Divider } from 'antd'
import { ViewComponent } from '../../components/BaseComponent'
import Filters, { FilterItem, Types } from '../../components/Filters'
import { MappingForm } from '../../components/Forms'
import MappingStats from '../../components/MappingStats'
import { PartnerProvider, PartnerConsumer, PartnerContextData } from '../../context/PartnerContext'
import { MappingStatsProvider, MappingStatsConsumer } from '../../context/MappingStatsContext'
import { MappingAgeProvider } from '../../context/MappingAgeContext'
import { MappingAgeRangeProvider } from '../../context/MappingAgeRangeContext'
import { MappingBreedProvider } from '../../context/MappingBreedContext'
import { MappingSexProvider } from '../../context/MappingSexContext'
import { MappingStateProvider } from '../../context/MappingStateContext'
import { MappingSizeProvider } from '../../context/MappingSizeContext'
import { MappingSpecieProvider } from '../../context/MappingSpecieContext'
import { MappingCharacteristicProvider } from '../../context/MappingCharacteristicContext'
import { MappingColorProvider } from 'context/MappingColorContext'
import { MappingBranchProvider } from 'context/MappingBranchContext'
import { ShelterProvider, ShelterConsumer, ShelterContextData } from 'context/ShelterContext'

// Viwes
import MappingAge from './Age'
import MappingAgeRange from './AgeRange'
import MappingBreed from './Breed'
import MappingSex from './Sex'
import MappingState from './State'
import MappingSize from './Size'
import MappingSpecie from './Specie'
import MappingCharacteristic from './Characteristic'
import MappingColor from './Color'
import MappingBranch from './Branch'
import { SearchOptions } from '../../components/TableHelper'

export default class Mapping extends Component {

  private partnerDispatchOptions = {
    options: {
      _force_ids: true,
      sort: ['key']
    }
  } as const

  state = {
    currentFilters: null as any,
    currentSearchOptions: null as any,
    shouldReload: false
  }

  static getDerivedStateFromProps(props: any, state: any) {
    const { location } = props
    if (location.state) {
      if (typeof location.state.search === 'object') {
        state.currentFilters = {
          ...state.currentFilters,
          ...location.state.search
        }
      }
    }

    return state
  }

  handleFiltersChange = (data: any) => {
    this.setState({
      currentFilters: data?.search || null
    })
  }

  handleFiltersClear = () => {
    const { history, location: { pathname } }: any = this.props

    history.replace(pathname, undefined)
  }

  handleModalClose = (activeTab: string, dispatchList?: any) => {
    const { history }: any = this.props
    const { shouldReload } = this.state

    history.replace(`/integration-mapping/${activeTab}`)

    if (shouldReload && dispatchList) {
      //dispatchList()
    }
  }

  handleListOnLoad = (searchOptions: SearchOptions) => {
    this.setState({
      currentSearchOptions: searchOptions
    })
  }

  /**
   * Force the active list to refetch by handing it a fresh `filters` reference
   * (same content). Each mapping list reloads on a `filters` prop change, so this
   * re-runs the current search without touching the applied filters or the URL.
   */
  forceReload = () => {
    const { currentFilters }: any = this.state
    this.setState({ currentFilters: { ...currentFilters } })
  }

  /**
   * Re-clicking the already-active tab refetches the current search. We swallow the
   * navigation (the tab Link would otherwise drop the query string) and just reload.
   */
  handleTabClick = (e: any, tab: string) => {
    const { activeTab } = (this.props as any).match.params
    if (tab === activeTab) {
      e.preventDefault()
      this.forceReload()
    }
  }

  /**
   * Clicking a Pending Mappings card that already points at the current view (same
   * path + query) is a no-op navigation, so it wouldn't refetch on its own. Detect
   * that case and force a reload; otherwise let the Link navigate normally.
   */
  handleCardClick = (e: any, tab: string) => {
    const { location }: any = this.props
    const current = `${location.pathname}${location.search}`
    const target = `/integration-mapping/${tab}?filter_active=false`
    if (current === target) {
      e.preventDefault()
      this.forceReload()
    }
  }

  private renderFilters(activeTab: string, currentFilters: any, values: any, handleFilterChange: any, partnerContext: PartnerContextData, shelterContext: ShelterContextData) {
    const partnersToFilter = !partnerContext.partners ? [] : partnerContext.partners.map(partner => {
      return {
        value: partner.key,
        text: partner.name || partner.key
      }
    })

    const sheltersToFilter = !shelterContext.shelters ? [] : shelterContext.shelters.map(shelter => {
      return {
        value: shelter.id,
        text: shelter.name
      }
    })

    const breakpoints = {
      // md:4,
      // xs:24, 
    }

    return <Row gutter={[8, 8]}>
      {["color", "branch"].includes(activeTab) && <>
        <Col {...breakpoints}>
          <FilterItem
            name="type_key"
            type={Types.SELECT}
            label="Type"
            placeholder="Filter by Type"
            value={values['type_key']}
            data={["DIRECT", "MATCH"].map(v => ({ text: v, value: v }))}
            options={{
              select: {
                allowClear: true,
                showSearch: true
              }
            }}
            onChange={handleFilterChange} />
        </Col>

        <Col {...breakpoints}>
          <FilterItem
            name="direction_key"
            type={Types.SELECT}
            label="Direction"
            placeholder="Filter by Direction"
            value={values['direction_key']}
            data={(
              values['type_key'] === 'DIRECT'
                ? ['BOTH']
                : values['type_key'] === 'MATCH'
                  ? ['INPUT', 'OUTPUT']
                  : ['INPUT', 'OUTPUT', 'BOTH']
            ).map(v => ({ text: v, value: v }))}
            options={{
              select: {
                allowClear: true,
                showSearch: true
              }
            }}
            onChange={handleFilterChange} />
        </Col>
      </>}

      <Col {...breakpoints}>
        <FilterItem
          name="partner_key"
          type={Types.SELECT}
          label="Partner"
          placeholder="Filter by Partner"
          loading={partnerContext.fetching}
          value={values['partner_key']}
          disabled={activeTab === 'age-range'}
          data={partnersToFilter}
          options={{
            select: {
              allowClear: true,
              showSearch: true
            }
          }}
          onChange={handleFilterChange} />
      </Col>

      <Col {...breakpoints}>
        <FilterItem
          name="name.ilike"
          type={Types.INPUT}
          label="Name"
          placeholder="Filter by Name"
          value={values['name.ilike']}
          disabled={activeTab === 'age-range'}
          options={{
            input: {
              allowClear: true
            }
          }}
          onChange={handleFilterChange} />
      </Col>

      <Col {...breakpoints}>
        <FilterItem
          name="external_id"
          type={Types.INPUT}
          label="External ID"
          placeholder="Filter by External ID"
          value={values['external_id']}
          disabled={activeTab === 'age-range'}
          options={{
            input: {
              allowClear: true
            }
          }}
          onChange={handleFilterChange} />
      </Col>

      <Col {...breakpoints}>
        <FilterItem
          name="active"
          type={Types.SELECT}
          label="Status"
          placeholder="Filter by Status"
          value={values['active']}
          defaultValue={currentFilters?.active}
          disabled={activeTab === 'age-range'}
          data={[
            {
              text: 'Active',
              value: 'true'
            },
            {
              text: 'Disabled',
              value: 'false'
            }
          ]}
          options={{
            select: {
              allowClear: true,
              showSearch: false
            }
          }}
          onChange={handleFilterChange} />
      </Col>

      <Col {...breakpoints}>
        <FilterItem
          name="shelter_id"
          type={Types.SELECT}
          label="Shelter"
          placeholder="Filter by Shelter"
          loading={shelterContext.fetching}
          value={values['shelter_id']}
          disabled={activeTab === 'age-range'}
          data={sheltersToFilter}
          options={{
            select: {
              allowClear: true,
              showSearch: true
            }
          }}
          onChange={handleFilterChange} />
      </Col>
    </Row>
  }

  renderAdd = (activeTab: string) => {
    const { permissions, history }: any = this.props

    // Cannot create :/
    if (!permissions.create) return null

    return (
      <Button type="primary" shape="round" onClick={() => history.push(`${activeTab}/add`)}>
        Add
      </Button>
    )
  }

  renderMapping = (activeTab: string) => {
    const { permissions, history }: any = this.props
    const { currentFilters } = this.state

    switch (activeTab) {
      case 'age':
        return <MappingAge {...this.props} permissions={permissions} filters={currentFilters} history={history} onLoad={this.handleListOnLoad} />
      case 'age-range':
        return <MappingAgeRange {...this.props} permissions={permissions} history={history} onLoad={this.handleListOnLoad} />
      case 'breed':
        return <MappingBreed {...this.props} permissions={permissions} filters={currentFilters} history={history} onLoad={this.handleListOnLoad} />
      case 'sex':
        return <MappingSex {...this.props} permissions={permissions} filters={currentFilters} history={history} onLoad={this.handleListOnLoad} />
      case 'state':
        return <MappingState {...this.props} permissions={permissions} filters={currentFilters} history={history} onLoad={this.handleListOnLoad} />
      case 'size':
        return <MappingSize {...this.props} permissions={permissions} filters={currentFilters} history={history} onLoad={this.handleListOnLoad} />
      case 'specie':
        return <MappingSpecie {...this.props} permissions={permissions} filters={currentFilters} history={history} onLoad={this.handleListOnLoad} />
      case 'color':
        return <MappingColor {...this.props} permissions={permissions} filters={currentFilters} history={history} onLoad={this.handleListOnLoad} />
      case 'branch':
        return <MappingBranch {...this.props} permissions={permissions} filters={currentFilters} history={history} onLoad={this.handleListOnLoad} />
      case 'characteristic':
        return <MappingCharacteristic {...this.props} permissions={permissions} filters={currentFilters} history={history} onLoad={this.handleListOnLoad} />
      default:
        return <Redirect to="/integration-mapping/age" exact />
    }
  }

  private renderMappingTabs(selectedKeys: string[]) {
    const tabs: { key: string, label: string }[] = [
      {
        key: "age",
        label: "Age"
      },
      {
        key: "age-range",
        label: "Age Range"
      },
      {
        key: "breed",
        label: "Breed"
      },
      {
        key: "sex",
        label: "Sex"
      },
      {
        key: "size",
        label: "Size"
      },
      {
        key: "specie",
        label: "Species"
      },
      {
        key: "color",
        label: "Color"
      },
      {
        key: "characteristic",
        label: "Characteristic"
      },
      {
        key: "branch",
        label: "Location"
      },
      {
        key: "state",
        label: "State"
      },
    ]

    return <Menu selectedKeys={selectedKeys} mode="horizontal">
      {tabs.map(tab =>
        <Menu.Item key={tab.key}>
          <Link to={tab.key} onClick={(e) => this.handleTabClick(e, tab.key)}>{tab.label}</Link>
        </Menu.Item>
      )}
    </Menu>
  }

  render() {
    const { permissions, history, match: { params: { activeTab, entityUuid } } }: any = this.props
    const { currentFilters, currentSearchOptions } = this.state

    if (!activeTab) return <Redirect to="/integration-mapping/age" exact />
    const selectedKeys = [activeTab] as any
    const modalVisible = entityUuid && entityUuid.length > 0

    return (
      <ShelterProvider>
        <MappingStatsProvider>
          <PartnerProvider>
            <MappingStatsConsumer>
              {({ fetching: fetchingStats, mappingPending, requestMappingStatsPending }) => (
                <PartnerConsumer>
                  {(partnerContext) => (
                    <ShelterConsumer>
                      {(shelterContext) => {
                        return (
                          <>
                            <MappingStats loading={fetchingStats} mappingPending={mappingPending} loadMappingPending={requestMappingStatsPending} onCardClick={this.handleCardClick} />

                            <Divider />

                            <Card title="Filters" style={{ marginBottom: 25 }}>
                              <Filters history={history} defaultSubmitOptions={this.partnerDispatchOptions} submitDispatch={this.handleFiltersChange} dispatches={[partnerContext.requestPartnerList, shelterContext.requestShelterList]} onClearFilters={this.handleFiltersClear}>
                                {({ values, handleFilterChange }: any) => (
                                  this.renderFilters(activeTab, currentFilters, values, handleFilterChange, partnerContext, shelterContext)
                                )}
                              </Filters>
                            </Card>

                            <MappingAgeProvider>
                              <MappingAgeRangeProvider>
                                <MappingBreedProvider>
                                  <MappingSexProvider>
                                    <MappingStateProvider>
                                      <MappingSizeProvider>
                                        <MappingSpecieProvider>
                                          <MappingCharacteristicProvider>
                                            <MappingColorProvider>
                                              <MappingBranchProvider>
                                                <Card title="Mappings" extra={this.renderAdd(activeTab)}>
                                                  {this.renderMappingTabs(selectedKeys)}

                                                  <div style={{ marginTop: 20 }}>
                                                    <ViewComponent permissions={permissions} check="list">
                                                      {this.renderMapping(activeTab)}
                                                    </ViewComponent>
                                                  </div>
                                                </Card>

                                                <Modal
                                                  title="Mapping"
                                                  visible={modalVisible}
                                                  footer={null}
                                                  destroyOnClose={true}
                                                  onCancel={() => this.handleModalClose(activeTab)}
                                                  width={750}
                                                >
                                                  {
                                                    // We should re-render the form, because our form trash need to be cleared
                                                    modalVisible ? (
                                                      <MappingForm
                                                        activeTab={activeTab}
                                                        uuid={entityUuid !== 'add' ? (entityUuid || null) : null}
                                                        searchOptions={currentSearchOptions}
                                                        loadingContent={partnerContext.fetching}
                                                        partners={partnerContext.partners}
                                                        loadPartners={partnerContext.requestPartnerList}
                                                        onSave={() => requestMappingStatsPending()}
                                                      />
                                                    ) : null
                                                  }
                                                </Modal>
                                              </MappingBranchProvider>
                                            </MappingColorProvider>
                                          </MappingCharacteristicProvider>
                                        </MappingSpecieProvider>
                                      </MappingSizeProvider>
                                    </MappingStateProvider>
                                  </MappingSexProvider>
                                </MappingBreedProvider>
                              </MappingAgeRangeProvider>
                            </MappingAgeProvider>
                          </>
                        )
                      }}
                    </ShelterConsumer>
                  )}
                </PartnerConsumer>
              )}
            </MappingStatsConsumer>
          </PartnerProvider>
        </MappingStatsProvider>
      </ShelterProvider>
    )
  }
}
